


































import Vue from 'vue'
import { ItemWithLinkInterface } from '@/config/interfaces'

export default Vue.extend({
  name: 'ItemWithLinkEl',
  props: {
    templateItemData: {
      type: Object as () => ItemWithLinkInterface,
      required: true
    }
  },
  computed: {
    imageStyle (): string {
      return 'background: ' + this.templateItemData.iconBox + ';'
    },
    separatorStyle (): string {
      return 'border-bottom: 1px solid ' + this.templateItemData.separator + ';'
    },
    text (): string {
      const text = this.templateItemData.text

      return text.includes('\n')
        ? text.replace(/\n/g, '<br>')
        : text
    }
  }
})
